module.exports = __webpack_public_path__ + "img/logo-icon.c7d88419.svg";